import templateUrl from './temporaryLogin.html'

/**
 * Temporary login route.
 *
 * @namespace routes.TemporaryLogin
 * @type {TmrRoute}
 */
export const route = {
  name: 'temporaryLogin',
  label: 'LOGIN.TITLE',
  component: 'tmrTemporaryLogin',
  url: '/temporary-login?token',
  accessControl: [],
  accessAnonymous: true,
}

/**
 * Temporary login component
 *
 * Executes {@link TmrApiAuth#temporaryLogin} when initialized.
 *
 * @type {ngComponent}
 */
export const tmrTemporaryLogin = {
  ngType: 'component',
  templateUrl,
}

/**
 * Access control for route {@link routes.temporaryLogin}
 *
 * @type {ngRun}
 */
function tmrTemporaryLoginRun($log, $transitions, TmrApiAuth) {
  'ngInject'
  // Redirect to not found page if token is missing.
  $transitions.onBefore({ to: 'app.temporaryLogin' }, trans => {
    if (!trans.params().token)
      return trans.router.stateService.target('app.error404')
  })
  // Try to login with url token; catch on error to show the temporaryLogin page.
  $transitions.onSuccess({ to: 'app.temporaryLogin' }, trans =>
    TmrApiAuth.temporaryLogin(trans.params().token).catch(err =>
      $log.error(err)
    )
  )
  // Redirect to change password page after login success.
  $transitions.onBefore({ from: 'app.temporaryLogin', to: 'app' }, trans =>
    trans.router.stateService.target('app.admin.users.password', null, {
      reload: true,
    })
  )
}

export { tmrTemporaryLoginRun as run }
